export default __webpack_public_path__ + "static/media/settings.c2c16b8e.svg";